import { render, staticRenderFns } from "./FiltroColuna.vue?vue&type=template&id=f9fca580&scoped=true"
import script from "./FiltroColuna.vue?vue&type=script&lang=js"
export * from "./FiltroColuna.vue?vue&type=script&lang=js"
import style0 from "./FiltroColuna.vue?vue&type=style&index=0&id=f9fca580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fca580",
  null
  
)

export default component.exports